import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home/Index";
import Gallery from "./pages/gallery/Indx";
import Roadmap from "./pages/roadmap/Index";
import TermsOfService from "./pages/tos/index";
import Aos from "aos";
import "aos/dist/aos.css";

const App = () => {
  useEffect(() => {
    Aos.init({
      duration: 1600,
    });
    Aos.refresh();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/roadmap" element={<Roadmap />} />
        <Route path="galleries" element={<Gallery />} />
        <Route path="/termsofservice" element={<TermsOfService />} />
      </Routes>
    </Router>
  );
};

export default App;
